import React, { Component } from 'react';
import config from '../Config';
import logo from '../assets/images/logo.svg';

class Services extends Component {
    constructor(props) {
        super(props);
        this.state = {
            services: [],
            loading: true,
            error: null,
            selectedItem: null
        };
    }

    async componentDidMount() {
        try {
            const type = "servizi"
            const response = await fetch(`/data/${type}.json`);

            document.title = `${config.name} ・ Servizi`;

            this.setState({type: type})

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            const defaultItem = data.items.find(item => item.id === 2);

            this.setState({
                items: data.items,
                selectedItem: defaultItem,
                loading: false,
            });
        
        } catch (error) {
            this.setState({
                error: error.message,
                loading: false,
            });
        }
    }

    handleClick = (id) => {
        const item = this.state.items.find(el => el.id === id);
        this.setState({ selectedItem: item });
      };

    render() {
        const { items, loading, error, type, selectedItem } = this.state;

        if (loading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>Error: {error}</div>;
        }

        return (
            <div className='b-light'>
                <div className='content-wrapper m-c p-tb-10'>
                    <h1 className='madegra animated-item fade-in-slide-up'>Spazi su misura</h1>
                    <ul className='m-t-3'>
                        <li className="c-100 d-i-b v-a-m">
                            <ul>
                                {items.map((item) => (
                                    <li key={item.id} onClick={() => this.handleClick(item.id)} className={`c-33 d-i-b pointer t-a-c animated-item fade-in-slide-up`}>
                                        <div className={`border-card-item p-1 sm-p-05 ${selectedItem && selectedItem.id === item.id ? "b-dark" : ""}`}>
                                            <h5 className={`madegra bold uppercase ${selectedItem && selectedItem.id === item.id ? "c-light" : "c-primary"}`}>{item.name}</h5>
                                        </div>  
                                    </li>
                                ))}
                            </ul>
                        </li>
                        <li className="c-100 d-i-b v-a-m">
                            {selectedItem && (
                                <div className='content-wrapper m-c'>
                                        <div className='t-a-c m-c animated-item fade-in-slide-up delay-2'>
                                            <div className='b-light border-wrapper'>
                                                <div className='border-card-item'>
                                                    <div className='p-1 p-lr-3 animated-item fade-in-slide-up b-light sm-p-lr-1'>
                                                        <ul>
                                                            <li className='c-40 d-i-b v-a-m sm-c-100'>
                                                                <img className='c-100' src={`/images/servizi/${selectedItem.name.toLowerCase().replace(' ', '')}.jpg`} />
                                                            </li>
                                                            <li className='c-60 p-l-1 d-i-b v-a-m t-a-l sm-c-100 sm-p-0 sm-t-a-c'>
                                                                <h3 className='uppercase ervasera madegra c-primary'>{selectedItem.name}</h3>
                                                                <p className='m-t-1 c-primary'>{selectedItem.text}</p>
                                                                <a href={`mailto:${config.email}?subject=Il mio progetto ${selectedItem.name}&body=Ciao Caterina,%0A%0AVorrei realizzare un progetto e sono interessato al servizio ${selectedItem.name}...`} className='m-t-2 s-f-s d-b t-a-c m-c b-primary c-light p-1 sans-serif uppercase'>Realizziamo il tuo progetto</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            )}
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default Services;
